import {
  disableSubmitButton,
  enableSubmitButton,
} from "./enableOrDisableSubmitButton";
import { validateEmailViaAjax } from "./validateEmailViaAjax";

const regexEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function checkEmail(email, input) {
  const $input = $(input);
  const $errorContainer = $input.parents(".field").find(".field__error");
  const $successContainer = $input.parents(".field").find(".field__help");
  const $fieldBox = $input.parents(".field__box");
  // Remove text from info area
  $errorContainer.empty().show();
  $successContainer.empty().show();
  // disableSubmitButton();
  validateEmailViaAjax(email, input);
}

function checkEmailInput($emailInput) {
  if (regexEmail.test($emailInput.val())) {
    $emailInput.removeClass("error");
    enableSubmitButton();
    if (!$emailInput.data('disable-ajax')) {
      validateEmailViaAjax($emailInput.val(), $emailInput);
    }
  } else {
    $emailInput.addClass("error");
    disableSubmitButton();
  }
}

// validate on pageload - direct AJAX request
$(document).ready(function () {
  const $email = $("#email");
  if ($email.length > 0) {
    checkEmailInput($email)
    $email.on("input", function (e) {
      checkEmailInput($email)
    });
  }
});
